import React from "react";
import ReactDOM from "react-dom/client";
// Component layer first, tokens + Tailwind second: both sides are single
// class selectors, so whichever is emitted last wins. Loading the design
// system first lets a utility (`bg-surface-muted` on a `.card`) override a
// component default, instead of losing to it silently.
import "@/styles/design-system.css";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
